module.exports = __webpack_public_path__ + "static/img/shareBG-btm.bf6a368.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/shareBG-btm.jpg
// module id = yrTL
// module chunks = 1